import * as API from '../../_api';
import * as Sentry from '@sentry/vue';

// @ts-ignore
export const createTemplate = async ({commit, dispatch}, {id, template}) => {
  try {
    await API.createTemplate(id, template);
    return true;
  } catch (ex: any) {
    Sentry.captureException(ex);
    dispatch('common/snackbar/error', 'Fatal Error. Please try again later', {root: true});
    return false;
  }
};

// @ts-ignore
export const readTemplates = async ({commit, dispatch}, {id}) => {
  try {
    const templates = await API.readTemplates(id);
    commit('setTemplates', templates);
    return true;
  } catch (ex: any) {
    Sentry.captureException(ex);
    dispatch('common/snackbar/error', 'Fatal Error. Please try again later', {root: true});
    return false;
  }
};

// @ts-ignore
export const updateTemplate = async ({commit, dispatch}, {id, template}) => {
  try {
    await API.updateTemplate(id, template);
    return true;
  } catch (ex: any) {
    Sentry.captureException(ex);
    dispatch('common/snackbar/error', 'Fatal Error. Please try again later', {root: true});
    return false;
  }
};

// @ts-ignore
export const deleteTemplate = async ({commit, dispatch}, {event, template}) => {
  try {
    await API.deleteTemplate(event, template);
    return true;
  } catch (ex: any) {
    Sentry.captureException(ex);
    dispatch('common/snackbar/error', 'Fatal Error. Please try again later', {root: true});
    return false;
  }
};
